import template from './required-hours.html';
import controller from './required-hours.controller';

let RequiredHoursModal = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  windowClass: "hmodal-info animated zoomIn"
};

export default RequiredHoursModal;



// WEBPACK FOOTER //
// ./client/pages/timesheet/modals/required-hours/required-hours.component.js